import { useSelector } from 'react-redux';
import { RootState } from '../../../services/store';

export default function useAdmins() {
	const { loading, updateLoading, items } = useSelector((store: RootState) => store.admins);

	return {
		loading,
		updateLoading,
		items,
	};
}
